import { ref } from "vue";
import { useStore } from "vuex";
import useTracking from "@/composables/useAdTracking";
import resolveAdUrl from "@/helpers/resolveAdUrl";
import useAuth from "@/composables/useAuth";

export function useAds() {
  const store = useStore();
  const track = useTracking();
  const hoverStartTime = ref(null);
  const hoverDurations = ref({});
  const ads = ref(null);
  const sideSquare = ref(null);
  const sideLong = ref(null);
  const before_featured_agencies = ref(null);
  const under_main_banner = ref(null);
  const under_subscription = ref(null);
  const under_newly_listed = ref(null);
  const top = ref(null);
  const { state } = useAuth();

  const loadAds = async () => {
    await store.dispatch("fetchAds");
    ads.value = store.state.ads;
    sideSquare.value = ads.value.property_page_side_square;
    sideLong.value = ads.value.property_page_side_long;
    before_featured_agencies.value = ads.value.h_before_featured_agencies;
    under_main_banner.value = ads.value.h_under_main_banner;
    under_subscription.value = ads.value.h_under_subscription;
    under_newly_listed.value = ads.value.h_under_newly_listed;
    top.value = ads.value.property_page_top;
  };

  const handleAdClick = async (ad, routeName) => {
    const userId = state.user?.id;
    const conversionType = "click";

    const metrics = {
      interactions: 1,
      avg_time_on_ad: calculateAvgTimeOnAd(ad.id),
      hovers: getHoversCount(ad.id),
    };

    // await track.incrementClicks("ads", ad.id, metrics);
    // await track.recordConversion(ad.id, userId, conversionType);
    // await track.recordPageView(ad.id, routeName);

    const url = resolveAdUrl(ad);
    window.open(url, "__blank");

    track
      .incrementClicks("ads", ad.id, metrics)
      .then(() => track.recordConversion(ad.id, userId, conversionType))
      .then(() => track.recordPageView(ad.id, routeName))
      .catch((error) => console.error("Error tracking ad click:", error));
  };

  const getHoversCount = () => {
    return Math.floor(Math.random() * 10);
  };

  const handleAdHoverStart = async () => {
    hoverStartTime.value = new Date();
  };

  const handleAdHoverEnd = async (ad) => {
    if (hoverStartTime.value) {
      const hoverEndTime = new Date();
      const hoverDuration = (hoverEndTime - hoverStartTime.value) / 1000;

      if (!hoverDurations.value[ad.id]) {
        hoverDurations.value[ad.id] = [];
      }
      hoverDurations.value[ad.id].push(hoverDuration);

      const avgTimeOnAd = calculateAvgTimeOnAd(ad.id);
      const hovers = hoverDurations.value[ad.id].length;

      await track.incrementImpressions("ads", ad.id, {
        avg_time_on_ad: avgTimeOnAd,
        hovers: hovers,
      });

      hoverStartTime.value = null;
    }
  };

  const calculateAvgTimeOnAd = (adId) => {
    const durations = hoverDurations.value[adId];
    if (!durations || durations.length === 0) return 0;

    const totalDuration = durations.reduce(
      (sum, duration) => sum + duration,
      0
    );
    return totalDuration / durations.length;
  };

  // const handlePageInteraction = async (ad, routeName) => {
  //   await track.recordPageView(ad, routeName);
  // };

  return {
    before_featured_agencies,
    under_main_banner,
    under_subscription,
    under_newly_listed,
    top,
    sideSquare,
    sideLong,
    // handlePageInteraction,
    handleAdClick,
    handleAdHoverStart,
    handleAdHoverEnd,
    resolveAdUrl,
    loadAds,
  };
}
